var React = require('react');

function QuoteInline (props) {
    return React.createElement("g",props,React.createElement("g",{"fill":"#BFD107","fillRule":"nonzero"},React.createElement("g",null,React.createElement("path",{"d":"M37.0403023,52 L61,34.1886792 L61,12 L37.0403023,12 L37.0403023,52 Z M3,52 L26.813602,34.1886792 L26.813602,12 L3,12 L3,52 Z"}))));
}

QuoteInline.defaultProps = {"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","transform":"translate(0, -40)"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
